<div class="surface-ground h-full min-h-screen versions-container">
  <div class="container p-4">
    <div class="flex justify-content-center">
      <div class="container-logo mb-3">
        <a routerLink="/">
          <div class="logo-teorema"></div>

          @if (config.panelTitle) {
            <h6 class="text-uppercase text-primary-800">
              {{ config.panelTitle }}
            </h6>
          }
        </a>
      </div>
    </div>

    @if (!loadingTags && !tags.length) {
      <div class="my-4">
        <div class="d-flex align-items-center justify-content-center">
          <patron-icon name="bi-x-circle" size="xl"></patron-icon>
          <h6 class="mb-0 ms-2">Nenhuma versão encontrada.</h6>
        </div>
      </div>
    }

    <patron-timeline [value]="tags" align="alternate" [oppositeTemplate]="contentTemplate">
      <ng-template #contentTemplate let-tag>
        <patron-card
          [titleTemplate]="cardTitleTemplate"
          [subtitleTemplate]="cardSubtitleTemplate"
          styleClass="mb-4">
          <ng-template #cardTitleTemplate>
            {{ tag.name }}
          </ng-template>
          <ng-template #cardSubtitleTemplate>
            {{ tag.target.date | date: 'dd/MM/yyyy HH:mm' }}
          </ng-template>

          <ul class="list-none text-left">
            @if (tag.channel_url) {
              <li class="flex align-items-center mb-2 channel-url">
                <patron-avatar class="me-2" color="primary">
                  <patron-icon name="bi-link-45deg" size="lg"></patron-icon>
                </patron-avatar>
                <small>
                  <a [href]="tag.channel_url" target="_blank">Channel URL</a>
                  @if (tag.expires) {
                    <small class="ms-2">{{ tag.expires }}</small>
                  }
                </small>
              </li>
            }
            @for (commit of tag.commits; track commit) {
              <li class="flex align-items-center mb-2">
                @if (commit.author.user?.links.avatar.href; as link) {
                  <span>
                    <patron-avatar [src]="link" class="me-2"></patron-avatar>
                  </span>
                } @else {
                  <patron-avatar class="me-2" color="secondary">
                    <patron-icon name="bi-person-fill" size="lg"></patron-icon>
                  </patron-avatar>
                }
                <a [href]="commit.links.html.href" target="_blank">{{ commit.message }}</a>
              </li>
            }
          </ul>
          <div class="text-center mt-4">
            <a [href]="tag.links.html.href" target="_blank">
              @if (tag.next) {
                <patron-button
                  color="primary"
                  variant="outline"
                  iconName="bi-three-dots"
                  size="sm"></patron-button>
              }
            </a>
          </div>
        </patron-card>
      </ng-template>
    </patron-timeline>
  </div>
</div>

@if (loadingTags) {
  <patron-overlay></patron-overlay>
}
